import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import { IHasTestData } from '../../../ui-toolkit/test-utilities/IHasTestData';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

interface StackTraceInfoButtonTWProps extends IHasTestData, ButtonHTMLAttributes<HTMLButtonElement> {}

export const StackTraceInfoButtonTW: React.FC<StackTraceInfoButtonTWProps> = ({
  children,
  className,
  onClick,
  ...rest
}) => {
  return (
    <button
      className={classNames(
        'min-h-fit rounded-full px-3 py-1.5 text-xs shadow-sm ring-1 ring-inset ring-red-700',
        className
      )}
      data-test-id={mergeTests(rest['data-test-id'], 'error-banner-tw-button')}
      data-test-class={mergeTests(rest['data-test-class'], 'error-banner-tw-button')}
      onClick={onClick}
    >
      <div className={'flex items-center gap-2'}>
        <InformationCircleIcon className={'text-blue h-6 w-6'} />
        {children}
      </div>
    </button>
  );
};
